<template>
  <div class="time-text">{{ time }}</div>
</template>

<script>
export default {
  name: 'clock',
  data () {
    return {
      time: ''
    }
  },
  mounted () {
    this.updateTime()
  },
  methods: {
    updateTime () {
      this.time = this.$moment().locale('ko').format('a hh:mm:ss')
      setTimeout(this.updateTime, 300)
    }
  }
}
</script>

<style>
</style>
